import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { BootstrapVue } from 'bootstrap-vue'
import i18n from "./i18n/i18n";

Vue.config.productionTip = false

// Install BootstrapVue
Vue.use(BootstrapVue)



new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
